import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { CommandPalette } from "@sd/components/CommandPalette";
import { Header } from "@sd/components/layout/Header";
import { Sidebar } from "@sd/components/layout/Sidebar";
import { useAgentCompactLayout } from "@sd/hooks/use-mobile";
import { sd } from "@sd/lib/sdPaths";
import { Sheet, SheetContent } from "@/components/ui/sheet";

export function TicketPanelShell({
  children,
  activeQueue,
}: {
  children: React.ReactNode;
  activeQueue: string;
}) {
  const navigate = useNavigate();
  const isCompact = useAgentCompactLayout();
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [commandPaletteOpen, setCommandPaletteOpen] = useState(false);

  const sidebarProps = {
    collapsed: sidebarCollapsed,
    onToggle: () => setSidebarCollapsed(c => !c),
    activeQueue,
    onQueueChange: () => {},
    activeTab: "tickets" as const,
    onTabChange: (tab: "tickets" | "assets") => {
      if (tab === "assets") navigate(sd(`assets/${activeQueue}`));
    },
  };

  return (
    <div className="flex h-screen flex-col overflow-hidden bg-background">
      <Header
        hideGlobalSearch
        onSearchClick={() => setCommandPaletteOpen(true)}
        onMobileMenuClick={() => setSidebarOpen(true)}
      />
      <CommandPalette
        open={commandPaletteOpen}
        onOpenChange={setCommandPaletteOpen}
        onCreateTicket={() => navigate(sd("tickets/new"))}
        onSelectTicket={() => {}}
      />
      <div className="flex min-h-0 flex-1 overflow-hidden">
        <div className="hidden shrink-0 lg:flex">
          <Sidebar {...sidebarProps} />
        </div>

        {isCompact ? (
          <Sheet open={sidebarOpen} onOpenChange={setSidebarOpen}>
            <SheetContent
              side="left"
              className="w-60 max-w-[85vw] p-0 [&>button]:hidden"
            >
              <Sidebar
                {...sidebarProps}
                collapsed={false}
                onNavigate={() => setSidebarOpen(false)}
              />
            </SheetContent>
          </Sheet>
        ) : null}

        <div className="min-h-0 min-w-0 flex-1 overflow-y-auto">{children}</div>
      </div>
    </div>
  );
}
